import consumerApi from "api/services/consumer-api";
import { Strain } from "custom-types/Strain";
import logError from "utils/logError";

type RecommendedStrainsProps = {
  data: object;
  lat: number;
  lon: number;
  version: string;
  productCategory: string[];
};

type RecommendedStrainsResponse = {
  strains: Strain[];
  categoriesBySlug: {
    [key: string]: string[];
  };
  allCategories: string[];
};

const getRecommendedStrains = async (
  props: RecommendedStrainsProps,
): Promise<RecommendedStrainsResponse> => {
  try {
    const res = await consumerApi.post(
      "/api/strains/v1/user_recommendation",
      props,
    );
    return res.data;
  } catch (e) {
    logError(e.message, {
      functionName: "getRecommendedStrains",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return { allCategories: [], categoriesBySlug: {}, strains: [] };
  }
};

export default getRecommendedStrains;
